
export default {
  props: {
    blok: {
      type: Object,
      default: () => ({
        content: [],
        footer: [],
        img: {},
        link: {},
        link_title: '',
      }),
    },
  },
}
